<template>
    <div>
        <!-- Onboarding Banner 1 -->
        <b-alert
            v-if="tab.onboarding_banner_1 === 0 && showNextBanner"
            show
            variant="info"
            dismissible
            @dismissed="dismissAndDelay('1')"
        >
            <p>
                <strong>Create Your First Feedback</strong><br>
                Start by making a new feedback request. Our AI moderation and duplicate detection help you get the best input from your users.
            </p>
            <b-button @click="createFeedback(); setOnboardingDone('1')" variant="primary">Create Feedback</b-button>
            <b-button @click="dismissAndDelay('1')" variant="link" class="text-muted">
                Skip <b-icon icon="arrow-right"></b-icon>
            </b-button>
        </b-alert>

        <!-- Onboarding Banner 2 -->
        <b-alert
            v-else-if="tab.onboarding_banner_2 === 0 && showNextBanner"
            show
            variant="warning"
            dismissible
            @dismissed="dismissAndDelay('2')"
        >
            <p>
                <strong>Create Product Vision Fast</strong><br>
                Quickly set up your product vision in the system using AI. It takes just 10 seconds and helps align your team and users.
            </p>
            <b-button @click="createProductVision(); setOnboardingDone('2')" variant="primary">
                Create Product Vision
            </b-button>
            <b-button @click="dismissAndDelay('2')" variant="link" class="text-muted">
                Skip <b-icon icon="arrow-right"></b-icon>
            </b-button>
        </b-alert>

        <!-- Onboarding Banner 3 -->
        <b-alert
            v-else-if="tab.onboarding_banner_3 === 0 && showNextBanner"
            show
            variant="success"
            dismissible
            @dismissed="dismissAndDelay('3')"
        >
            <p>
                <strong>Prioritize Your Feedback</strong><br>
                Focus on what matters most by prioritizing feedback. Use AI assistance or traditional methods like RICE and MoSCoW.
            </p>
            <b-button @click="aiPrioritization(); setOnboardingDone('3')" variant="primary">
                AI Prioritization
            </b-button>
            <b-button @click="traditionalPrioritization(); setOnboardingDone('3')" variant="primary">
                Score-Based Prioritization
            </b-button>
            <b-button @click="dismissAndDelay('3')" variant="link" class="text-muted">
                Skip <b-icon icon="arrow-right"></b-icon>
            </b-button>
        </b-alert>
    </div>
</template>

<script>
export default {
    props: {
        tab: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showNextBanner: true, // Controls the display of banners
            nextBannerDelay: 5000, // Delay before showing the next banner (in ms)
        };
    },
    methods: {
        dismissAndDelay(key) {
            // Mark the current banner as dismissed immediately
            this.$set(this.tab, `onboarding_banner_${key}`, -1);
            this.$emit('onboarding-dismissed', `onboarding_banner_${key}`);

            // Temporarily hide all banners
            this.showNextBanner = false;

            // Show the next banner after a delay
            setTimeout(() => {
                this.showNextBanner = true;
            }, this.nextBannerDelay);
        },
        setOnboardingDone(key) {
            this.$set(this.tab, `onboarding_banner_${key}`, 1); // Mark as done
            this.$emit('onboarding-done', `onboarding_banner_${key}`);

            // Temporarily hide all banners
            this.showNextBanner = false;

            // Show the next banner after a delay
            setTimeout(() => {
                this.showNextBanner = true;
            }, this.nextBannerDelay);
        },
        createFeedback() {
            this.$emit('create-feedback'); // Notify parent to open feedback creation
        },
        createProductVision() {
            this.$emit('create-product-vision'); // Notify parent to create product vision
        },
        aiPrioritization() {
            this.$emit('ai-prioritization'); // Notify parent to start AI prioritization
        },
        traditionalPrioritization() {
            this.$emit('traditional-prioritization'); // Notify parent to start RICE/MoSCoW prioritization
        },
    },
};
</script>